import { IAction } from "../../../interface/action.interface";
import { ChangeLogColumns } from "../enum/change-log-columns";
import { IChangeLogDto } from "../interface/dto/change-log.dto";

export enum ChangeLogActionTypes {
    CHANGE_LOG_INIT = "CHANGE_LOG_INIT",
    CHANGE_LOG_LOAD_LISTS = "CHANGE_LOG_LOAD_LISTS",
    CHANGE_LOG_LOAD_ERROR = "CHANGE_LOG_LOAD_ERROR",
    CHANGE_LOG_LOAD_SUCCESS = "CHANGE_LOG_LOAD_SUCCESS",
    CHANGE_LOG_SET_PAGINATION = "CHANGE_LOG_SET_PAGINATION",
    CHANGE_LOG_SET_SEARCHQUERY = "CHANGE_LOG_SET_SEARCHQUERY",
    CHANGE_LOG_SET_SORTING = "CHANGE_LOG_SET_SORTING",
    CHANGE_LOG_EXPORT = "CHANGE_LOG_EXPORT",
}

export interface IChangeLogInitAction extends IAction {
    type: ChangeLogActionTypes.CHANGE_LOG_INIT;
}

export interface IChangeLogLoadAction extends IAction {
    type: ChangeLogActionTypes.CHANGE_LOG_LOAD_LISTS;
}

export interface IChangeLogLoadErrorAction extends IAction {
    type: ChangeLogActionTypes.CHANGE_LOG_LOAD_ERROR;
    payload: { error: string };
}

export interface IChangeLogLoadSuccessAction extends IAction {
    type: ChangeLogActionTypes.CHANGE_LOG_LOAD_SUCCESS;
    payload: IChangeLogDto;
}

export interface IChangeLogSetPaginationAction extends IAction {
    type: ChangeLogActionTypes.CHANGE_LOG_SET_PAGINATION;
    payload: {
        currentPage: number;
        itemsPerPage: number;
    };
}

export interface IChangeLogSetSearchQueryAction extends IAction {
    type: ChangeLogActionTypes.CHANGE_LOG_SET_SEARCHQUERY;
    payload: string;
}

export interface IChangeLogSetSortingAction extends IAction {
    type: ChangeLogActionTypes.CHANGE_LOG_SET_SORTING;
    payload: {
        column: ChangeLogColumns;
        order: "asc" | "desc";
    };
}

export interface IChangeLogExportAction extends IAction {
    type: ChangeLogActionTypes.CHANGE_LOG_EXPORT;
}

export const changeLogInitAction = (): IChangeLogInitAction => ({
    type: ChangeLogActionTypes.CHANGE_LOG_INIT,
    payload: {},
});

export const changeLogLoadAction = (): IChangeLogLoadAction => ({
    type: ChangeLogActionTypes.CHANGE_LOG_LOAD_LISTS,
    payload: {},
});

export const changeLogLoadErrorAction = (
    error: string,
): IChangeLogLoadErrorAction => ({
    type: ChangeLogActionTypes.CHANGE_LOG_LOAD_ERROR,
    payload: { error },
});

export const changeLogLoadSuccessAction = (
    data: IChangeLogDto,
): IChangeLogLoadSuccessAction => ({
    type: ChangeLogActionTypes.CHANGE_LOG_LOAD_SUCCESS,
    payload: data,
});

export const changeLogSetPaginationAction = (
    currentPage: number,
    itemsPerPage: number,
): IChangeLogSetPaginationAction => ({
    type: ChangeLogActionTypes.CHANGE_LOG_SET_PAGINATION,
    payload: { currentPage, itemsPerPage },
});

export const changeLogSetSearchQueryAction = (
    searchQuery: string,
): IChangeLogSetSearchQueryAction => ({
    type: ChangeLogActionTypes.CHANGE_LOG_SET_SEARCHQUERY,
    payload: searchQuery,
});

export const changeLogSetSortingAction = (
    column: ChangeLogColumns,
    order: "asc" | "desc",
): IChangeLogSetSortingAction => ({
    type: ChangeLogActionTypes.CHANGE_LOG_SET_SORTING,
    payload: { column, order },
});

export const changeLogExportAction = () => ({
    type: ChangeLogActionTypes.CHANGE_LOG_EXPORT,
    payload: {},
});

export type IChangeLogActions =
    | IChangeLogInitAction
    | IChangeLogLoadAction
    | IChangeLogLoadErrorAction
    | IChangeLogLoadSuccessAction
    | IChangeLogSetPaginationAction
    | IChangeLogSetSearchQueryAction
    | IChangeLogSetSortingAction
    | IChangeLogExportAction;
